import { render, staticRenderFns } from "./PanelInputArea.vue?vue&type=template&id=61f6f814&scoped=true&"
import script from "./PanelInputArea.vue?vue&type=script&lang=js&"
export * from "./PanelInputArea.vue?vue&type=script&lang=js&"
import style0 from "./PanelInputArea.vue?vue&type=style&index=0&id=61f6f814&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f6f814",
  null
  
)

export default component.exports